import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '../reducers';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import authInterceptor from '../middleware/middleware';

const configureStore = () => {
  if (process.env.NODE_ENV === 'production') {
    return createStore(reducer, applyMiddleware(thunkMiddleware, authInterceptor));
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ serialize: true })
    : compose;

  const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(thunkMiddleware, authInterceptor, loggerMiddleware))
  );

  return store;
};

export default configureStore;
